export default {"src":"/_next/static/media/fire.2b96b12b.svg","height":11,"width":9,"blurWidth":0,"blurHeight":0};